
var app = angular.module('directives.bankDetails', []);

require('./directives/bankDetails.js');
require('./stylesheets/bankDetails.scss');
require('./templates/index.html');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/bankDetails/index.js
 ** module id = 131
 ** module chunks = 1
 **/